
const m = window.require("@ember/application/deprecations");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
